import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { colors } from "healthex-common/colors";
import { DocumentRetrievalLocationStatus, DocumentRetrievalTaskSource } from "healthex-common/document.retrieval.dtos";
import { observer } from "mobx-react";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Check, Error, ErrorContainer, LocationCardContainer, LocationFallbackIcon, LocationHeader, LocationInfoContainer, LocationLeftContent, LocationLogo, LocationLogoContainer, LocationName, LocationSubtitle, NewProviderBullet, NewProviderLabelRow, NewProviderLabelText, } from "./DocumentRetrievalComponents.styles";
import { DocumentSelectionLabelText } from "./DocumentRetrievalDocumentSelectionView.styles";
import { HXTooltipWrapperView } from "./HXTooltipWrapperView";
import { withLoadTracking } from "./withLoadTracking";
const isParticleLocationSource = (source) => source === DocumentRetrievalTaskSource.PARTICLE_EPIC || source === DocumentRetrievalTaskSource.PARTICLE_FASTEN;
const LocationLogoWithLoadTracking = withLoadTracking(LocationLogo);
export const LocationLogoOrFallback = ({ logoUrl, name }) => {
    const [imgFailed, setImgFailed] = useState(false);
    useEffect(() => {
        setImgFailed(false);
    }, [logoUrl]);
    if (logoUrl && !imgFailed) {
        return (_jsx(LocationLogoContainer, { children: _jsx(LocationLogoWithLoadTracking, { src: logoUrl, alt: name, onError: () => setImgFailed(true) }) }));
    }
    return _jsx(LocationFallbackIcon, { children: name.charAt(0).toUpperCase() });
};
export const NewProviderLabel = () => {
    const { t } = useTranslation(["patients"]);
    return (_jsxs(NewProviderLabelRow, { children: [_jsx(NewProviderBullet, {}), _jsx(NewProviderLabelText, { children: t("New provider") })] }));
};
export const LocationSecondaryLabel = ({ location, needsAuth = false, hideNewProviderLabel = false }) => {
    const { t } = useTranslation(["patients"]);
    if (needsAuth) {
        return _jsx(DocumentSelectionLabelText, { children: t("Skipped, log in to access") });
    }
    if (isParticleLocationSource(location.source)) {
        return _jsx(LocationSubtitle, { children: t("You may have records here") });
    }
    if (location.addedBy && !hideNewProviderLabel) {
        return _jsx(NewProviderLabel, {});
    }
    return null;
};
export const LocationCard = observer((props) => {
    const { location, index, totalCount, hideNewProviderLabel = false } = props;
    const isFirst = index === 0;
    const isLast = index === totalCount - 1;
    const isChecked = location.status === DocumentRetrievalLocationStatus.COMPLETE ||
        location.status === DocumentRetrievalLocationStatus.IN_PROGRESS ||
        location.status === DocumentRetrievalLocationStatus.ERROR;
    const isErrorState = location.status === DocumentRetrievalLocationStatus.NEEDS_AUTH || location.status === DocumentRetrievalLocationStatus.SKIPPED;
    const { t } = useTranslation(["patients"]);
    return (_jsx(LocationCardContainer, { isFirst: isFirst, isLast: isLast, isError: isErrorState, children: _jsxs(LocationHeader, { children: [_jsxs(LocationLeftContent, { children: [_jsx(LocationLogoOrFallback, { logoUrl: location.logoUrl, name: location.name }), _jsxs(LocationInfoContainer, { children: [_jsx(LocationName, { children: location.name }), _jsx(LocationSecondaryLabel, { location: location, hideNewProviderLabel: hideNewProviderLabel })] })] }), isChecked ? (_jsx(Check, {})) : isErrorState ? (_jsx(HXTooltipWrapperView, { tooltip: t("This provider requires you to login to their portal to access records. Tap Continue to review providers."), arrow: true, placement: "top-start", addTouchControls: true, children: _jsx(ErrorContainer, { children: _jsx(Error, {}) }), maxWidth: 152, offset: [0, -20], color: colors.black_lighter, backgroundColor: colors.white_main, boxShadow: "0 8px 24px 0 rgba(0, 0, 0, 0.15)", padding: "4px 8px" })) : (_jsx(_Fragment, {}))] }) }, location.key));
});
